import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAgendarExamesRenachIntegrado } from './types';

// ACTIONS
import {
	agendarExamesRenachIntegradoSuccess,
	agendarExamesRenachIntegradoFailure,
} from './actions';

function* agendarExamesRenachIntegrado(request: ReducerAction) {
	const { payload }: { payload: IRequestAgendarExamesRenachIntegrado } =
		request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/agendar-exames`,
		payload,
	);

	if (response.status === 200) {
		yield put(agendarExamesRenachIntegradoSuccess(response));
	} else {
		yield put(agendarExamesRenachIntegradoFailure(response));
	}
}

export default all([
	takeLatest(
		Types.AGENDAR_EXAMES_RENACH_INTEGRADO_REQUEST,
		agendarExamesRenachIntegrado,
	),
]);
